import React from 'react';
import { cn } from '~/helpers/utils';

type ProfileLogoProps = {
  src?: string;
  alt: string;
  widthClass?: string;
  spacingClass?: string;
  imageClass?: string;
  placeholderImage?: string;
}

const ProfileLogo: React.FC<ProfileLogoProps> = ({
  src,
  alt,
  widthClass,
  spacingClass,
  imageClass,
  placeholderImage,
}) => {
  const placeholder: string = placeholderImage || '/images/office-logo-placeholder.png';
  
  return (
    <div className={cn('office-profile__logo', spacingClass || 'p-2')}>
      <div className={cn('relative aspect-square', widthClass || 'w-20 md:w-28')}>
        <img
          src={src || placeholder}
          alt={alt}
          className={cn('absolute w-full h-full object-contain', imageClass)}
        />
      </div>
    </div>
  );
};

export default ProfileLogo;